import { ApiResponse, TokenData, Industry } from '../models';
import * as http from './http';
import ApiService from './service';

export class IndustryService extends ApiService {
  public async loadAllIndustry() {
    const url = `${this.apiDomain}/api/industry`;

    const resposne = await http.get<ApiResponse<Industry[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateIndustry(data: Industry, id?: string) {
    const url = `${this.apiDomain}/api/industry/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  
  public async createIndustry(data: Industry) {
    const url = `${this.apiDomain}/api/industry`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteIndustry(id?: string) {
    const url = `${this.apiDomain}/api/industry/${id}`;

    const response = await http.remove<ApiResponse<Industry>>(url, this.store);
    return response.data;
  }
}
